var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_719_635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.45457 28.5731L6.3913 27.3223C7.66954 26.4819 7.76631 25.7197 7.76631 25.5047C7.36099 23.4117 6.31834 21.4987 4.78378 20.0324C4.44785 19.7015 4.01216 19.493 3.54566 19.4399C3.07916 19.3868 2.60842 19.4921 2.20789 19.7392L1.53008 20.1497C1.28702 20.2974 1.07591 20.4931 0.909485 20.725C0.74306 20.9569 0.624753 21.2203 0.561478 21.4994C0.498203 21.7786 0.491307 22.0677 0.541265 22.3496C0.591222 22.6315 0.696924 22.9003 0.852154 23.14L1.49131 24.1562L12.5695 40.6904C12.9636 41.2995 13.486 41.8134 14.0995 42.1954C15.2478 42.9367 16.6377 43.1962 17.9729 42.9185L33.8154 39.7914L43.0149 42.977C43.2715 43.0686 43.5438 43.1072 43.8155 43.0906C44.0872 43.074 44.3528 43.0025 44.5966 42.8804C44.8405 42.7583 45.0575 42.5881 45.235 42.3798C45.4124 42.1714 45.5466 41.9293 45.6295 41.6676C45.7808 41.1593 45.7349 40.612 45.5012 40.1366C45.2674 39.6612 44.8632 39.2933 44.3706 39.1074L33.4668 35.0618L15.6876 38.0129",
    stroke: "#A0A09F",
    strokeWidth: 1.17675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5144 26.2476C7.95985 26.5212 17.6629 32.8143 16.2879 36.9772C16.1558 37.3786 15.9376 37.7456 15.6487 38.0521L14.3317 39.3616",
    stroke: "#A0A09F",
    strokeWidth: 1.17675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7964 42.5863L18.8636 48.8013H13.0534C12.0261 48.8013 11.0408 49.2131 10.3144 49.9462C9.58797 50.6792 9.17993 51.6734 9.17993 52.7101V54.5668H38.657",
    stroke: "#A0A09F",
    strokeWidth: 1.17675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9641 41.531L30.0965 48.6646H39.9544C40.9817 48.6646 41.967 49.0764 42.6934 49.8094C43.4198 50.5424 43.8279 51.5367 43.8279 52.5734",
    stroke: "#A0A09F",
    strokeWidth: 1.17675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5906 33.6156L19.2316 31.5439H31.6461",
    stroke: "#A0A09F",
    strokeWidth: 1.17675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8638 48.8013H24.9645",
    stroke: "#A0A09F",
    strokeWidth: 1.17675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1428 22.671L15.1067 8.85352L16.9466 6.68405C17.2684 6.3093 17.6609 6.00303 18.1013 5.78307C18.5417 5.56311 19.0211 5.43395 19.5115 5.40302C20.0019 5.37209 20.4935 5.44003 20.9576 5.60295C21.4216 5.76586 21.849 6.02044 22.2145 6.35183L32.6535 15.342C33.0212 15.6589 33.3234 16.0457 33.5429 16.4805C33.7624 16.9153 33.8947 17.3895 33.9325 17.8759C33.9703 18.3623 33.9127 18.8515 33.763 19.3155C33.6133 19.7794 33.3744 20.2091 33.0601 20.5799L31.1428 22.671Z",
    stroke: "#A0A09F",
    strokeWidth: 1.17675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5647 9.22471L28.5666 5.68726H38.6183",
    stroke: "#A0A09F",
    strokeWidth: 1.17675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2959 11.2965L30.4844 8.69714L35.6168 8.79486",
    stroke: "#A0A09F",
    strokeWidth: 1.17675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1297 18.1368L19.8708 19.6417",
    stroke: "#A0A09F",
    strokeWidth: 1.17675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3212 15.0098L15.2805 15.3811",
    stroke: "#A0A09F",
    strokeWidth: 1.17675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7322 20.9121L24.8484 23.6092",
    stroke: "#A0A09F",
    strokeWidth: 1.17675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_719_635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKid);
export default __webpack_public_path__ + "static/media/kid.485c4f2c465f8a9cc09110ba9750ff73.svg";
export { ForwardRef as ReactComponent };